import React from 'react';
import RectangularButton from 'components/elements/molecules/RectangularButton/RectangularButton';
import { Icon, ICONS } from '../../Icons';

export default function SyllabusUploadStepPreferenceSuccess({
  deliveryPreferences,
  onDone,
}) {
  const deliveryDay = deliveryPreferences?.deliveryDay || 'Sunday';
  const autoPublish = deliveryPreferences?.autoPublishWithoutReview;

  const bullets = [
    {
      text: `On ${deliveryDay}s, you'll receive articles for the upcoming week.`,
    },
    {
      text: autoPublish
        ? "You've decided to send these to students without a review."
        : "You've decided to review them before they go to students.",
    },
    {
      text: 'Click preferences at any time to change this.',
    },
  ];

  return (
    <div className="syllabus-step">
      <div className="main-con">
        <div className="modal-header">
          <div className="syllabus-step-title">
            You've configured your news suggestions.
          </div>
        </div>
        <div className="section-con">
          <ul className="syllabus-step3-bullets">
            {bullets.map(({ text }, i) => (
              <li key={i} className="syllabus-step3-bullet">
                <Icon icon={ICONS.CHECK} className="syllabus-step3-check" />
                <span>{text}</span>
              </li>
            ))}
          </ul>
        </div>
        <div className="syllabus-step-footer">
          <div />
          <RectangularButton darkButton onClick={onDone}>
            Done
          </RectangularButton>
        </div>
      </div>
    </div>
  );
}
